module.exports = __webpack_public_path__ + "static/media/Icon6.5a7570da.png";